import React, { useMemo } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import classnames from 'classnames';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { Text } from '../components/text';
import { Table } from '../components/table';
import { Button } from '../components/button';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
import { mobileFullWidthColumnClassName } from '../utils/defaults';
import { BdiWrapper } from '../components/bdi-wrapper';
export const SectionSubscribe = (props) => {
    const { t } = useTranslation();
    const { section: { button, inputField, placeholderText, consent: { shouldRequireConsent }, }, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(SectionSubscribeTitle, { ...props }),
        React.createElement(SectionSubscribeForm, { ...props },
            React.createElement(SectionSubscribeInputForm, { ...props },
                React.createElement(SectionSubscribeInput, { ...props },
                    React.createElement("a", { href: button.href, style: {
                            color: inputField.color,
                            height: '100%',
                            textDecoration: 'none',
                            width: '100%',
                        }, target: "_blank" },
                        React.createElement(LinkWrapper, null,
                            React.createElement(BdiWrapper, { text: placeholderText
                                    ? placeholderText
                                    : t('COMPOSER.SUBSCRIBE.ERRORS.EMAIL_PLACEHOLDER') })))),
                shouldRequireConsent && React.createElement(ConsentSection, { ...props })),
            React.createElement(SectionSubscribeButton, { ...props }))));
};
export const SectionSubscribeTitle = (props) => {
    const { section: { backgroundColor, borderBottom, borderLeft, borderRight, borderTop, title, titleCssClass, titleOuterPadding, titleInnerPadding, }, columnCssClass, cssClass, isRtl, } = props;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: classnames(cssClass, titleCssClass), padding: shorthand(titleOuterPadding) },
            React.createElement(Column, { padding: shorthand(titleInnerPadding), cssClass: classnames(columnCssClass, mobileFullWidthColumnClassName) },
                React.createElement(Text, { align: isRtl ? 'right' : 'left', color: title.color, fontFamily: title.fontFamily, fontSize: title.fontSize, fontStyle: title.fontStyle, fontWeight: title.fontWeight?.toString(), lineHeight: `${title.lineHeight}px`, padding: "0px", textDecoration: title.textDecoration },
                    React.createElement("div", { style: { width: '100%', direction: isRtl ? 'rtl' : 'ltr' } },
                        React.createElement(BdiWrapper, { text: title.text })))))));
};
export const SectionSubscribeForm = (props) => {
    const { section: { backgroundColor, borderBottom, borderLeft, borderRight, borderTop, formOuterPadding, formCssClass, }, cssClass, isRtl, children, } = props;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: classnames(cssClass, formCssClass), direction: isRtl ? 'rtl' : 'ltr', padding: shorthand(formOuterPadding) }, children)));
};
export const SectionSubscribeButton = (props) => {
    const { section: { button, formInnerPadding, columnsWidths }, columnCssClass, isRtl, onSubscribeClick, experiments, } = props;
    const height = 43;
    const buttonBorderWidth = button.border
        .split(' ')
        .map((e) => parseInt(e, 10))
        .filter((e) => !isNaN(e))
        .pop() || 0;
    const noLeftPadding = shorthand({ ...formInnerPadding, left: 0 });
    const noRightPadding = shorthand({ ...formInnerPadding, right: 0 });
    return (React.createElement(Column, { cssClass: classnames('html-emails-subscribe-button-container', columnCssClass, mobileFullWidthColumnClassName), direction: isRtl ? 'rtl' : 'ltr', verticalAlign: "top", width: columnsWidths[1], padding: isRtl ? noRightPadding : noLeftPadding },
        React.createElement(Button, { backgroundColor: button.backgroundColor, border: button.border, borderRadius: button.borderRadius.toString(), color: button.color, cssClass: "html-emails-subscribe-button", fontFamily: button.fontFamily, fontSize: button.fontSize, fontStyle: button.fontStyle, fontWeight: button.fontWeight?.toString(), height: `${height - 2 * buttonBorderWidth}px`, href: button.href, innerPadding: "0 10px", padding: "0", width: "100%", textDecoration: button.textDecoration, onClick: onSubscribeClick, experiments: experiments },
            React.createElement(LinkWrapper, { fontWeight: "inherit" },
                React.createElement(BdiWrapper, { text: button.text })))));
};
export const SectionSubscribeInputForm = (props) => {
    const { section: { columnsWidths, formInnerPadding }, isRtl, columnCssClass, children, } = props;
    const noLeftPadding = shorthand({ ...formInnerPadding, left: 0 });
    const noRightPadding = shorthand({ ...formInnerPadding, right: 0 });
    const cssClass = classnames('html-emails-subscribe-input-container', columnCssClass, mobileFullWidthColumnClassName);
    return (React.createElement(Column, { cssClass: cssClass, verticalAlign: "top", width: columnsWidths[0], padding: isRtl ? noLeftPadding : noRightPadding },
        React.createElement(Table, { padding: "0", borderCollapse: "separate" }, children)));
};
export const SectionSubscribeInput = (props) => {
    const { section: { button, inputField }, isRtl, children, } = props;
    const height = 43;
    const inputBorderWidth = 1;
    const direction = isRtl ? 'rtl' : 'ltr';
    const textAlign = isRtl ? 'right' : 'left';
    const inputBorderRadius = useMemo(() => button.borderRadius.toString()
        ? { borderRadius: button.borderRadius.toString() }
        : {}, [button.borderRadius]);
    const tdStyles = useMemo(() => ({
        border: `solid ${inputBorderWidth}px ${inputField.borderColor}`,
        textAlign,
        fontSize: 11,
        backgroundColor: '#fff',
        paddingLeft: '20px',
        paddingRight: '20px',
        height: `${height - 2 * inputBorderWidth}px`,
        direction,
        ...inputBorderRadius,
    }), [direction, inputBorderRadius, inputField.borderColor, textAlign]);
    // In some cases react-dom fails re-rendering component with new styles, manually adding a key forces the component to re-render on style change
    const tdStylesKey = useMemo(() => Object.values(tdStyles).join(''), [tdStyles]);
    return (React.createElement("tr", null,
        React.createElement("td", { key: tdStylesKey, colSpan: 2, style: tdStyles }, children)));
};
const ConsentSection = (props) => {
    const { section: { consent: { consentCheckboxText, shouldShowConsentLink, consentLinkText, consentLinkUrl, consentTextStyle, }, inputField, button: { href }, }, isRtl, } = props;
    const direction = isRtl ? 'rtl' : 'ltr';
    const textAlign = isRtl ? 'right' : 'left';
    const fontSize = '14px';
    const textStyle = {
        ...consentTextStyle,
        textAlign,
        fontSize,
        lineHeight: '18px',
        direction,
    };
    const linkStyle = {
        ...textStyle,
        textDecoration: 'underline',
        marginLeft: '5px',
    };
    const checkboxStyle = {
        paddingLeft: '14px',
        height: '15px',
        border: `solid 1px ${inputField.borderColor}`,
        backgroundColor: '#ffffff',
        marginRight: isRtl ? '0' : '12px',
        marginLeft: isRtl ? '12px' : '0',
    };
    const commonStyle = {
        textAlign,
        direction,
        padding: `15px 0 0`,
        verticalAlign: 'top',
    };
    const getColumns = () => {
        const columns = [
            React.createElement("a", { href: href, style: checkboxStyle, target: "_blank" }),
            React.createElement(React.Fragment, null,
                React.createElement("a", { style: textStyle, target: "_blank", href: href },
                    React.createElement(LinkWrapper, null,
                        React.createElement(BdiWrapper, { text: consentCheckboxText }))),
                shouldShowConsentLink && (React.createElement("a", { style: linkStyle, target: "_blank", href: consentLinkUrl },
                    React.createElement(LinkWrapper, null,
                        React.createElement(BdiWrapper, { text: consentLinkText }))))),
        ];
        return isRtl ? [...columns.reverse()] : [...columns];
    };
    return (React.createElement("tr", null,
        React.createElement("td", { style: { ...commonStyle, width: isRtl ? '100%' : 'initial' } }, getColumns()[0]),
        React.createElement("td", { style: { ...commonStyle, width: isRtl ? 'initial' : '100%' } }, getColumns()[1])));
};
//# sourceMappingURL=section-subscribe.js.map